import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  geoJsonPriceIndexChangedRate: {},
  geoJsonPriceIndexChangedRateInit: false,
  geoJsonPriceCountChangedRate: {},
  geoJsonPriceCountChangedRateInit: false,
};

const reducers = {
  getGeoJsonPriceIndexChangedRate(state, action) {
    const payload = action.payload;
    state.geoJsonPriceIndexChangedRate = payload;
    state.geoJsonPriceIndexChangedRateInit = true;
  },
  getGeoJsonPriceCountChangedRate(state, action) {
    const payload = action.payload;
    state.geoJsonPriceCountChangedRate = payload;
    state.geoJsonPriceCountChangedRateInit = true;
  },
};

export const slice = createSlice({
  name: "rank",
  initialState,
  reducers,
});

export const { reducer } = slice;
